import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class SteckbriefSelectorConfiguration {

    /**
     * Base path where the steckbriefe are stored
     */
    @JsonProperty()
    declare downloadUrl: string;

    constructor() {}
}
